import styled from 'styled-components';
import { Spacer } from '@lux/tokens';
export const SkipLinkWrapper = styled.div.withConfig({ displayName: "SkipLinkWrapper", componentId: "sc-1iuypa2" }) `display:flex;justify-content:center;padding:${Spacer.S} 0;transform:translateY(-300%);position:absolute;&:focus-within{transform:translateX(0%);position:relative;}`;
//# sourceMappingURL=styles.js.map